import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { NotYetTranslatedText, T } from '../../../../../../Translations';
import { LearningDesignSection } from '../../../Types';

interface Props {
  label: NotYetTranslatedText;
  onClick: () => void;
  isChecked: boolean;
  icon: React.ReactNode;
  section: LearningDesignSection;
}

function DisplayTypeChoice({ label, onClick, isChecked, icon, section }: Props) {
  return (
    <label
      className={clsx(
        'border-2 bg-gray-10 w-36 rounded-lg pt-1.5 px-3 ' +
          (isChecked ? 'border-teal-600 text-teal-600' : 'border-gray-300'),
      )}
      onClick={onClick}
    >
      <div className="flex flex-row justify-left">
        <input
          type="radio"
          name={`displayType-${section.resource.payload.id}`}
          className="mt-1 inline-block h-5 w-5 text-teal-600"
          defaultChecked={isChecked}
          readOnly
        />
        <span className="text-sm font-semibold pt-1 px-1">
          <T kind={label.translationKey} />
        </span>
      </div>
      <div className="flex flex-row justify-center pt-2.5">{icon}</div>
    </label>
  );
}

export default observer(DisplayTypeChoice);
